export const colorsScss = {
  grey: '#d8d8d8',
  primary: '#364759',
  secondaryLight: '#dce1e9',
  warningDark: '#fe9000',
};
